export const CHANGED_RATING = "CHANGED_RATING";
export const DELETED_RATING = "DELETED_RATING";
export const RECEIVED_RATING = "RECEIVED_RATING";
export const FETCHED_RATING = "FETCHED_RATING";
